module.exports = __webpack_public_path__ + "static/img/package_2.d01f70d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/package_2.jpg
// module id = oH2K
// module chunks = 1